import { Component, Input, LOCALE_ID, Inject, ElementRef, ViewChild, ChangeDetectorRef } from "@angular/core";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { CvNumberLocalizePipe } from "src/app/reusables/pipes/cv-number-localize.pipe";
import { SupervisorService } from "../supervisor.service";
import { ViewType } from "../supervisor.model";
import { SupervisorObject } from "../supervisor.model";

@Component({
    selector: "cxone-agent-card",
    templateUrl: "./cxone-agent-card.component.html",
    styleUrl: "./cxone-agent-card.component.scss",
})
export class CxoneAgentCardComponent {
    @Input() supervisor: SupervisorObject;

    @ViewChild('tooltipLoginName') tooltipLoginName!: ElementRef;
    @ViewChild('tooltipTeam') tooltipTeam!: ElementRef;
    isTextTruncated = false;
    viewType = ViewType;

    constructor(
        @Inject(LOCALE_ID) private locale: string,
        public changeDetector: ChangeDetectorRef,
        public cvLocalizationService: CVLocalizationService,
        public cvNumberLocalizePipe: CvNumberLocalizePipe,
        private supervisorService: SupervisorService
    ) {
    }

    async ngOnInit() {
        await this.loadLocalization();
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection("Games_Module");
        } catch {
            console.error("Failed to load localization for Games");
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        return this.cvLocalizationService.getCachedText("Games_Module", key, defaultValue);
    }

    displayTooltip(tooltipFor: string, tooltip: string): string {
        let element = tooltipFor == 'loginName' ? this.tooltipLoginName?.nativeElement : this.tooltipTeam?.nativeElement;
        this.isTextTruncated = element?.scrollWidth > element?.clientWidth;
        return this.isTextTruncated ? tooltip : '';
    }

    retrievedCurrentView() {
        let views: number;
        this.supervisorService.getCurrentView().subscribe(view => {
            views = view;
        });
        return views;
    }

    updatedCurrentView() {
        this.supervisorService.setCurrentView(this.supervisor?.LoginID);
    }
}
